import React from 'react';
import ReactApexChart from 'react-apexcharts';
import ArrowRightIcon from '../ArrowRightIcon';
import { useNavigate } from 'react-router-dom';

const ActiveInactiveChart = ({ title, data, viewAllLink, colors }) => {
  const navigate = useNavigate();
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
  const chartData = {
    series: [
      {
        name: 'Active',
        data: Array.isArray(data?.active) ? data.active : []
      },
      {
        name: 'Inactive',
        data: Array.isArray(data?.inactive) ? data.inactive : []
      }
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: false,
        toolbar: {
          show: false
        }
      },
      colors: colors || ['#91CC75', '#5470C6'],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: months,
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Poppins, sans-serif'
          }
        }
      },
      yaxis: {
        title: {
          text: 'Count',
          style: {
            fontSize: '14px',
            fontWeight: 400,
            fontFamily: 'Poppins, sans-serif'
          }
        },
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Poppins, sans-serif'
          }
        }
      },
      legend: {
        show: true,
        showForSingleSeries: false,
        showForNullSeries: true,
        showForZeroSeries: true,
        position: 'bottom',
        horizontalAlign: 'center', 
        floating: false,
        fontSize: '14px',
        fontFamily: 'Helvetica, Arial',
        fontWeight: 400,
        formatter: undefined,
        inverseOrder: false,
        width: undefined,
        height: undefined,
        tooltipHoverFormatter: undefined,
        customLegendItems: [],
        clusterGroupedSeries: true,
        clusterGroupedSeriesOrientation: 'vertical',
        offsetX: 0,
        offsetY: 0,
        labels: {
            colors: undefined,
            useSeriesColors: false
        },
        markers: {
            size: 9,
            shape: undefined,
            strokeWidth: 1,
            fillColors: undefined,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0
        },
    },
    
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          }
        }
      }
    }
  };

  return (
    <div className="bg-white rounded-lg p-4 shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
        {viewAllLink && (
          <button 
            onClick={() => navigate(viewAllLink)}
            className="text-[#00ADEF] text-[16px] font-poppins font-[500] border border-[#00ADEF] rounded-[6px] px-4 py-2 transition hover:bg-[#E6F7FB] flex items-center">
            View All
            <ArrowRightIcon className="ml-2" />
          </button>
        )}
      </div>
      <div className="h-[350px]">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height="100%"
        />
      </div>
    </div>
  );
};

export default ActiveInactiveChart; 
